import { AdminApp } from '../admin/AdminApp';
import { HomePage } from '../public/pages/HomePage';

export function CurrentRoute() {
  if (window.location.pathname.startsWith('/admin')) {
    return <AdminApp />;
  }

  return <HomePage />;
}
